import React, { useEffect, useState } from 'react';
import styles from './MemberCard.module.scss';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import newsUpdated from '../../../assets/Imagess/updated-member.png';
import DeletePopup from '../Custom/DeletePopup';
import FacultyMemberInfo from './FacultyMemberInfo';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { useDeleteFacultyMember } from '../../../Hooks/Teams';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function MemberCard({ data, refetch }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const customizedToast = useToast();

  const {
    mutate: deleteMember,
    isLoading: isDeletingMember,
    isSuccess,
  } = useDeleteFacultyMember(data?.facultyId);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => navigate(`/home/edit-faculty/${data?.facultyId}`),
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    refetch();
  }, [isDeletingMember]);

  useEffect(() => {
    if (isSuccess) {
      // setShowCheckmark(true);
      customizedToast.open('تم الحذف بنجاح');
      // setTimeout(() => {
      //   setShowCheckmark(false);
      // }, 2000);
    }
  }, [isSuccess]);

  return (
    <div className={styles['news-card']}>
      {isEmpty(data?.facultyImage) ? (
        <img
          src={noImageFound}
          className={styles['news-card-image']}
          onClick={() => setShowInfo(true)}
        />
      ) : (
        <img
          src={sanitizeAndValidateUrl(`${data?.url}${data?.facultyImage}`)}
          className={styles['news-card-image']}
          onClick={() => setShowInfo(true)}
        />
      )}
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
            left
          />
          <div>
            <p className={styles['key']}>الاسم</p>
            <p className={styles['value']}>{data?.fullName_AR}</p>
            <p className={styles['key']}>منصب</p>
            <p className={styles['value']}>
              {!isEmpty(data?.positionAR) ? data?.positionAR : '-'}
            </p>
          </div>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title='عضو هيئة التدريس'
          handleDelete={() => {
            deleteMember();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingMember}
        />
      )}
      {showInfo && (
        <FacultyMemberInfo
          data={data}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsUpdated} />
        </div>
      )}
    </div>
  );
}

export default MemberCard;
